import { useState } from "react";
import { useStock } from "../App";
import { db } from "../firebase";
// 🔥 query, where, getDocs add kora hoyeche real ID khujar jonno
import { doc, updateDoc, deleteDoc, addDoc, collection, query, where, getDocs } from "firebase/firestore";

const statusStyle = {
  "In Stock":     { background: "#dcfce7", color: "#15803d" },
  "Low Stock":    { background: "#fef9c3", color: "#a16207" },
  "Out of Stock": { background: "#fee2e2", color: "#b91c1c" },
};

const getStatus = (stock, lowLimit) => {
  if (stock <= 0) return "Out of Stock";
  if (stock <= lowLimit) return "Low Stock";
  return "In Stock";
};

const Icons = {
  Edit: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path></svg>,
  Warning: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>
};

export default function ProductsPage() {
  const { products, sales } = useStock(); 
  const [search, setSearch] = useState("");
  
  const [editProduct, setEditProduct] = useState(null);
  const [lossAmount, setLossAmount]   = useState("");
  const [editName, setEditName]       = useState("");

  const getSoldQty = (productId) => {
    let soldCount = 0;
    const product = products.find(p => p.id === productId);
    if (!product) return 0;
    sales.forEach(s => {
      if (s.status === "Completed" && s.receiptItems) {
        const soldItem = s.receiptItems.find(i => i.name === product.name);
        if (soldItem) soldCount += soldItem.qty;
      }
    });
    return soldCount;
  };

  const filtered = products.filter(p => p.name.toLowerCase().includes(search.toLowerCase()) || p.id.toLowerCase().includes(search.toLowerCase()));

  const inStockCount = products.filter(p => getStatus(p.stock, p.lowLimit) === "In Stock").length;
  const lowStockCount = products.filter(p => getStatus(p.stock, p.lowLimit) === "Low Stock").length;
  const outOfStockCount = products.filter(p => getStatus(p.stock, p.lowLimit) === "Out of Stock").length;

  const openEditModal = (product) => {
    setEditProduct(product);
    setEditName(product.name);
    setLossAmount("");
  };

  const handleSaveEdit = async (e) => {
    e.preventDefault();
    const loss = parseFloat(lossAmount) || 0;
    const newStock = editProduct.stock - loss;

    try {
      // 🔥 ERROR FIX: Asol Firebase ID khuje ber kora
      const productQuery = query(collection(db, "products"), where("id", "==", editProduct.id));
      const querySnapshot = await getDocs(productQuery);
      
      if (querySnapshot.empty) {
        throw new Error("Product document not found in Cloud Database.");
      }
      
      const realFirebaseDocId = querySnapshot.docs[0].id;
      const productRef = doc(db, "products", realFirebaseDocId);

      // Loss record add kora
      if (loss > 0) {
        const lossValue = loss * parseFloat(editProduct.unitCost || 0);
        const now = new Date();
        await addDoc(collection(db, "sales"), {
          id: `#LS-${Math.floor(1000 + Math.random() * 9000)}`,
          customer: "Inventory Loss",
          // 🔥 NEW: Items summary te Name er pashe ID add kora hoyeche
          itemsSummary: `${editProduct.name} [ID: ${editProduct.id}] (x${loss})`,
          amount: `-$${lossValue.toFixed(2)}`,
          amountNum: 0, 
          lossCost: lossValue,
          status: "Loss",
          date: now.toISOString().split('T')[0],
          time: now.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true }),
          wallet: "N/A",
          createdAt: new Date()
        });
      }

      // Stock komano ba ekebare remove kora
      if (newStock <= 0) {
        await deleteDoc(productRef);
      } else {
        await updateDoc(productRef, { stock: newStock, name: editName });
      }

      setEditProduct(null);
      setLossAmount("");
    } catch (err) {
      alert("Update failed: " + err.message);
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
      
      {/* Premium Summary Cards */}
      <div className="grid-4">
        {[
          { label: "Total Products", value: products.length,  icon: "📦", color: "#6366f1", bg: "#eef2ff" },
          { label: "In Stock",       value: inStockCount,     icon: "✅", color: "#10b981", bg: "#d1fae5" },
          { label: "Low Stock",      value: lowStockCount,    icon: "⚠️", color: "#f59e0b", bg: "#fef3c7" },
          { label: "Out of Stock",   value: outOfStockCount,  icon: "❌", color: "#ef4444", bg: "#fee2e2" },
        ].map((s, i) => (
          <div key={i} style={{ background: "white", borderRadius: 14, border: "1px solid #e2e8f0", padding: "18px 20px", boxShadow: "0 1px 3px 0 rgba(0,0,0,0.05)" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 12 }}>
              <span style={{ fontSize: 12, color: "#94a3b8", fontWeight: 500 }}>{s.label}</span>
              <div style={{ width: 36, height: 36, borderRadius: 10, background: s.bg, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18 }}>{s.icon}</div>
            </div>
            <p className="font-display" style={{ fontSize: 24, fontWeight: 700, color: "#0f172a", margin: 0, fontFamily: "system-ui" }}>{s.value}</p>
          </div>
        ))}
      </div>

      <div style={{ background: "white", borderRadius: 14, border: "1px solid #e2e8f0", padding: "20px", boxShadow: "0 1px 3px 0 rgba(0,0,0,0.05)" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16, flexWrap: "wrap", gap: 10 }}>
          <div>
            <p style={{ fontSize: 15, fontWeight: 600, color: "#0f172a", margin: 0 }}>Product Catalog</p>
            <p style={{ fontSize: 12, color: "#94a3b8", marginTop: 2 }}>{filtered.length} products found in inventory</p>
          </div>
          <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8, background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 9, padding: "7px 12px" }}>
              <span style={{ fontSize: 13 }}>🔍</span>
              <input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search products..." style={{ border: "none", outline: "none", background: "transparent", fontSize: 13, color: "#0f172a", width: 140 }} />
            </div>
          </div>
        </div>

        <div className="table-responsive">
          <table style={{ width: "100%", borderCollapse: "collapse", minWidth: "650px" }}>
            <thead>
              <tr style={{ borderBottom: "1px solid #f1f5f9" }}>
                {["Product ID", "Name", "Price", "Stock", "Sold", "Status", "Action"].map((h) => (
                  <th key={h} style={{ textAlign: "left", fontSize: 11, color: "#94a3b8", fontWeight: 600, padding: "0 8px 10px", textTransform: "uppercase", letterSpacing: "0.5px" }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtered.map((p, i) => {
                const status = getStatus(p.stock, p.lowLimit);
                const soldAmount = getSoldQty(p.id);
                return (
                  <tr key={p.id} style={{ borderBottom: "1px solid #f8fafc" }} onMouseEnter={(e) => e.currentTarget.style.background = "#fafafa"} onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}>
                    <td style={{ padding: "14px 8px", fontSize: 12, color: "#6366f1", fontWeight: 600 }}>{p.id}</td>
                    <td style={{ padding: "14px 8px", fontSize: 13, color: "#0f172a", fontWeight: 600 }}>{p.name}</td>
                    <td style={{ padding: "14px 8px", fontSize: 13, color: "#0f172a", fontWeight: 600 }}>{p.price}</td>
                    <td style={{ padding: "14px 8px", fontSize: 13, color: "#0f172a", fontWeight: 700 }}>{p.stock} <span style={{fontSize:10, color:"#94a3b8", fontWeight: 500}}>{p.unit}</span></td>
                    <td style={{ padding: "14px 8px", fontSize: 13, color: "#64748b", fontWeight: 600 }}>{soldAmount}</td>
                    <td style={{ padding: "14px 8px" }}><span style={{ ...statusStyle[status], fontSize: 11, fontWeight: 600, padding: "4px 10px", borderRadius: 20, whiteSpace: "nowrap" }}>{status}</span></td>
                    <td style={{ padding: "14px 8px" }}>
                      <button onClick={() => openEditModal(p)} style={{ background: "#f1f5f9", color: "#475569", border: "1px solid #e2e8f0", padding: "6px 10px", borderRadius: 6, cursor: "pointer", display: "flex", alignItems: "center", gap: 6, fontSize: 11, fontWeight: 600, transition: "all 0.2s" }} onMouseEnter={e => { e.currentTarget.style.background = "#e2e8f0"; e.currentTarget.style.color = "#0f172a"; }} onMouseLeave={e => { e.currentTarget.style.background = "#f1f5f9"; e.currentTarget.style.color = "#475569"; }}>
                        {Icons.Edit} Edit / Loss
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {products.length === 0 && <p style={{ textAlign: "center", color: "#94a3b8", fontSize: 13, padding: "40px 0" }}>Inventory is empty. Add products from Stock.</p>}
        </div>
      </div>

      {editProduct && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(15, 23, 42, 0.6)", backdropFilter: "blur(4px)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 100, padding: 20 }}>
          <div style={{ background: "white", padding: 28, borderRadius: 16, width: "100%", maxWidth: 400, boxShadow: "0 20px 25px -5px rgba(0,0,0,0.1)" }}>
            <h3 style={{ margin: "0 0 6px", color: "#0f172a", fontSize: 18, fontWeight: 700 }}>Edit Product</h3>
            <p style={{ margin: "0 0 20px", color: "#64748b", fontSize: 13 }}>Update details or record damaged/lost items.</p>
            
            <form onSubmit={handleSaveEdit} style={{ display: "flex", flexDirection: "column", gap: 16 }}>
              <div>
                <label style={{ fontSize: 12, color: "#64748b", fontWeight: 600, display: "block", marginBottom: 6 }}>Product Name</label>
                <input required value={editName} onChange={e => setEditName(e.target.value)} style={{ width: "100%", padding: "10px 12px", borderRadius: 8, border: "1px solid #cbd5e1", outline: "none", boxSizing: "border-box", fontSize: 13, color: "#0f172a", fontWeight: 500 }} />
              </div>
              <div style={{ display: "flex", gap: 12 }}>
                <div style={{ flex: 1, background: "#f8fafc", padding: "12px", borderRadius: 8, border: "1px solid #e2e8f0" }}>
                  <p style={{ margin: "0 0 4px 0", fontSize: 11, color: "#64748b", fontWeight: 600, textTransform: "uppercase" }}>Current Stock</p>
                  <p style={{ margin: 0, fontSize: 18, fontWeight: 800, color: "#10b981", fontFamily: "system-ui" }}>{editProduct.stock} <span style={{ fontSize: 12, fontWeight: 500, color: "#94a3b8" }}>{editProduct.unit}</span></p>
                </div>
              </div>
              <div style={{ background: "#fff1f2", padding: "16px", borderRadius: 8, border: "1px solid #fecaca" }}>
                <label style={{ fontSize: 12, color: "#b91c1c", fontWeight: 600, display: "flex", alignItems: "center", gap: 6, marginBottom: 8 }}>{Icons.Warning} Record Loss (Damaged/Expired)</label>
                <div style={{ position: "relative" }}>
                  <input type="number" step="any" min="0" max={editProduct.stock} placeholder={`Enter loss amount in ${editProduct.unit}`} value={lossAmount} onChange={e => setLossAmount(e.target.value)} style={{ width: "100%", padding: "10px 12px", borderRadius: 8, border: "1px solid #fca5a5", outline: "none", boxSizing: "border-box", fontSize: 13, background: "white", color: "#b91c1c", fontWeight: 600 }} />
                  <span style={{ position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)", fontSize: 12, color: "#f87171", fontWeight: 600 }}>{editProduct.unit}</span>
                </div>
                {lossAmount > 0 && (
                  <p style={{ margin: "8px 0 0 0", fontSize: 11, color: "#991b1b", fontWeight: 500 }}>
                    New stock will be: <strong style={{ fontSize: 12 }}>{editProduct.stock - parseFloat(lossAmount)} {editProduct.unit}</strong>
                    { (editProduct.stock - parseFloat(lossAmount)) <= 0 && " (Product will be removed)" }
                  </p>
                )}
              </div>
              <div style={{ display: "flex", gap: 10, marginTop: 8 }}>
                <button type="button" onClick={() => setEditProduct(null)} style={{ flex: 1, padding: "10px", borderRadius: 8, border: "1px solid #cbd5e1", background: "white", cursor: "pointer", fontWeight: 600, color: "#64748b", transition: "background 0.2s" }} onMouseEnter={e => e.target.style.background = "#f8fafc"} onMouseLeave={e => e.target.style.background = "white"}>Cancel</button>
                <button type="submit" style={{ flex: 1, padding: "10px", borderRadius: 8, border: "none", background: "#4f46e5", color: "white", fontWeight: 600, cursor: "pointer", transition: "background 0.2s" }} onMouseEnter={e => e.target.style.background = "#4338ca"} onMouseLeave={e => e.target.style.background = "#4f46e5"}>Save Changes</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}